function _e(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, i = Array(e); t < e; t++) i[t] = r[t];
  return i;
}
function ar(r) {
  if (Array.isArray(r)) return _e(r);
}
function sr(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function tn(r, e, t, i, a, s, u) {
  try {
    var v = r[s](u), p = v.value;
  } catch (d) {
    return void t(d);
  }
  v.done ? e(p) : Promise.resolve(p).then(i, a);
}
function H(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(i, a) {
      var s = r.apply(e, t);
      function u(p) {
        tn(s, i, a, u, v, "next", p);
      }
      function v(p) {
        tn(s, i, a, u, v, "throw", p);
      }
      u(void 0);
    });
  };
}
function ur(r, e, t) {
  return e = pe(e), gr(r, Je() ? Reflect.construct(e, t || [], pe(r).constructor) : e.apply(r, t));
}
function Q(r, e) {
  if (!(r instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function cr(r, e, t) {
  if (Je()) return Reflect.construct.apply(null, arguments);
  var i = [null];
  i.push.apply(i, e);
  var a = new (r.bind.apply(r, i))();
  return t && ye(a, t.prototype), a;
}
function on(r, e) {
  for (var t = 0; t < e.length; t++) {
    var i = e[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(r, yn(i.key), i);
  }
}
function $(r, e, t) {
  return e && on(r.prototype, e), t && on(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function pn(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = wn(r)) || e) {
      t && (r = t);
      var i = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return i >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[i++]
          };
        },
        e: function(p) {
          throw p;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, u = !0, v = !1;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var p = t.next();
      return u = p.done, p;
    },
    e: function(p) {
      v = !0, s = p;
    },
    f: function() {
      try {
        u || t.return == null || t.return();
      } finally {
        if (v) throw s;
      }
    }
  };
}
function G(r, e, t) {
  return (e = yn(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function pe(r) {
  return pe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, pe(r);
}
function lr(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && ye(r, e);
}
function fr(r) {
  try {
    return Function.toString.call(r).indexOf("[native code]") !== -1;
  } catch {
    return typeof r == "function";
  }
}
function Je() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Je = function() {
    return !!r;
  })();
}
function dr(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function vr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function an(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    e && (i = i.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function T(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? an(Object(t), !0).forEach(function(i) {
      G(r, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : an(Object(t)).forEach(function(i) {
      Object.defineProperty(r, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return r;
}
function gr(r, e) {
  if (e && (typeof e == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return sr(r);
}
function C() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var r, e, t = typeof Symbol == "function" ? Symbol : {}, i = t.iterator || "@@iterator", a = t.toStringTag || "@@toStringTag";
  function s(k, E, K, he) {
    var ke = E && E.prototype instanceof v ? E : v, oe = Object.create(ke.prototype);
    return J(oe, "_invoke", function(O, I, x) {
      var A, j, B, U = 0, ae = x || [], X = !1, z = {
        p: 0,
        n: 0,
        v: r,
        a: ne,
        f: ne.bind(r, 4),
        d: function(P, N) {
          return A = P, j = 0, B = r, z.n = N, u;
        }
      };
      function ne(P, N) {
        for (j = P, B = N, e = 0; !X && U && !W && e < ae.length; e++) {
          var W, R = ae[e], se = z.p, re = R[2];
          P > 3 ? (W = re === N) && (B = R[(j = R[4]) ? 5 : (j = 3, 3)], R[4] = R[5] = r) : R[0] <= se && ((W = P < 2 && se < R[1]) ? (j = 0, z.v = N, z.n = R[1]) : se < re && (W = P < 3 || R[0] > N || N > re) && (R[4] = P, R[5] = N, z.n = re, j = 0));
        }
        if (W || P > 1) return u;
        throw X = !0, N;
      }
      return function(P, N, W) {
        if (U > 1) throw TypeError("Generator is already running");
        for (X && N === 1 && ne(N, W), j = N, B = W; (e = j < 2 ? r : B) || !X; ) {
          A || (j ? j < 3 ? (j > 1 && (z.n = -1), ne(j, B)) : z.n = B : z.v = B);
          try {
            if (U = 2, A) {
              if (j || (P = "next"), e = A[P]) {
                if (!(e = e.call(A, B))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                B = e.value, j < 2 && (j = 0);
              } else j === 1 && (e = A.return) && e.call(A), j < 2 && (B = TypeError("The iterator does not provide a '" + P + "' method"), j = 1);
              A = r;
            } else if ((e = (X = z.n < 0) ? B : O.call(I, z)) !== u) break;
          } catch (R) {
            A = r, j = 1, B = R;
          } finally {
            U = 1;
          }
        }
        return {
          value: e,
          done: X
        };
      };
    }(k, K, he), !0), oe;
  }
  var u = {};
  function v() {
  }
  function p() {
  }
  function d() {
  }
  e = Object.getPrototypeOf;
  var w = [][i] ? e(e([][i]())) : (J(e = {}, i, function() {
    return this;
  }), e), y = d.prototype = v.prototype = Object.create(w);
  function D(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, d) : (k.__proto__ = d, J(k, a, "GeneratorFunction")), k.prototype = Object.create(y), k;
  }
  return p.prototype = d, J(y, "constructor", d), J(d, "constructor", p), p.displayName = "GeneratorFunction", J(d, a, "GeneratorFunction"), J(y), J(y, a, "Generator"), J(y, i, function() {
    return this;
  }), J(y, "toString", function() {
    return "[object Generator]";
  }), (C = function() {
    return {
      w: s,
      m: D
    };
  })();
}
function J(r, e, t, i) {
  var a = Object.defineProperty;
  try {
    a({}, "", {});
  } catch {
    a = 0;
  }
  J = function(s, u, v, p) {
    if (u) a ? a(s, u, {
      value: v,
      enumerable: !p,
      configurable: !p,
      writable: !p
    }) : s[u] = v;
    else {
      let d = function(w, y) {
        J(s, w, function(D) {
          return this._invoke(w, y, D);
        });
      };
      d("next", 0), d("throw", 1), d("return", 2);
    }
  }, J(r, e, t, i);
}
function ye(r, e) {
  return ye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, i) {
    return t.__proto__ = i, t;
  }, ye(r, e);
}
function pr(r) {
  return ar(r) || dr(r) || wn(r) || vr();
}
function yr(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(r, e);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function yn(r) {
  var e = yr(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Ae(r) {
  "@babel/helpers - typeof";
  return Ae = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ae(r);
}
function wn(r, e) {
  if (r) {
    if (typeof r == "string") return _e(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _e(r, e) : void 0;
  }
}
function ze(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ze = function(t) {
    if (t === null || !fr(t)) return t;
    if (typeof t != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(t)) return e.get(t);
      e.set(t, i);
    }
    function i() {
      return cr(t, arguments, pe(this).constructor);
    }
    return i.prototype = Object.create(t.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ye(i, t);
  }, ze(r);
}
var de = "1.64.4", je = "2025-07-24 08:46:16 AM";
function V(r) {
  for (var e, t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    i[a - 1] = arguments[a];
  (e = console).log.apply(e, ["".concat(He(), " ").concat(r)].concat(i));
}
function _(r) {
  for (var e, t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    i[a - 1] = arguments[a];
  (e = console).warn.apply(e, ["".concat(He(), " ").concat(r)].concat(i));
}
function M(r) {
  for (var e, t = new Error().stack, i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
    a[s - 1] = arguments[s];
  (e = console).error.apply(e, ["".concat(He(), " ").concat(r)].concat(a, ["stack", t]));
}
function He() {
  return "[".concat(ve(), "] [v").concat(de, "] ");
}
function ve(r) {
  var e = navigator.language || "en-US", t = r || /* @__PURE__ */ new Date();
  return t.toLocaleString(e, {
    hour12: !1
  });
}
var mn = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, null, [{
    key: "isIOS",
    value: function() {
      return !!(!window.chrome && window.webkit) && "ontouchend" in document;
    }
  }, {
    key: "isMacOS",
    value: function() {
      return !!(!window.chrome && window.webkit) && !("ontouchend" in document);
    }
  }]);
}(), hn = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!((e = t.chrome) !== null && e !== void 0 && e.webview) && !!(t.unifyConfig || t.android_config);
}, wr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!(e.chrome && e.webkit && (e.unifyConfig || e.android_config));
}, De = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = t.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "ios" || Ue && mn.isIOS();
}, Ke = function() {
  var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = t.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" || Ue && mn.isMacOS();
}, mr = function() {
  var e, t, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = i.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" && ((t = i.unifyConfig) === null || t === void 0 || (t = t.systemParam) === null || t === void 0 || (t = t.webviewName) === null || t === void 0 ? void 0 : t.toLowerCase()) === "webkit";
}, hr = function() {
  var e, t, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return ((e = i.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "mac" && ((t = i.unifyConfig) === null || t === void 0 || (t = t.systemParam) === null || t === void 0 || (t = t.webviewName) === null || t === void 0 ? void 0 : t.toLowerCase()) === "cef";
}, br = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return De(e) || Ke(e);
}, bn = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
  return !!(e.android && e.android_config);
}, Sn = function() {
  var e;
  return ((e = window) === null || e === void 0 || (e = e.unifyConfig) === null || e === void 0 || (e = e.systemParam) === null || e === void 0 || (e = e.deviceOs) === null || e === void 0 ? void 0 : e.toLowerCase()) === "linux";
}, Y = {
  isAndroid: bn,
  isWebView2: hn,
  isCEF: wr,
  isMacOSOrIOS: br,
  isMacOS: Ke,
  isMacOSWebkit: mr,
  isMacOSCEF: hr,
  isIOS: De,
  isLinux: Sn
}, Ue = !1;
function sn() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (t || !window.unifyConfig && !window.android_config && _("The @zoom/hybrid-jssdk only supports UnifyWebView. Please ensure that the window.unifyConfig or window.android_config object exists, or set legacyPlatformDetection: true to skip UnifyWebView detection."), Y.isCEF(window)) {
    var i;
    return V("isCEF"), (e == null ? void 0 : e.linuxJSBridgeObject) || ((i = window.webkit) === null || i === void 0 || (i = i.messageHandlers) === null || i === void 0 ? void 0 : i.jsOCHelper);
  }
  if (Y.isWebView2(window)) {
    var a;
    return V("isWebView2"), (e == null ? void 0 : e.windowJSBridgeObject) || ((a = window.chrome) === null || a === void 0 ? void 0 : a.webview);
  }
  if (Y.isMacOSOrIOS(window)) {
    var s, u;
    return V("isMacOSOrIOS"), (e == null ? void 0 : e.macOrIOSJSBridgeObject) || ((s = window.webkit) === null || s === void 0 || (s = s.messageHandlers) === null || s === void 0 ? void 0 : s.unifyJSObj) || ((u = window.webkit) === null || u === void 0 || (u = u.messageHandlers) === null || u === void 0 ? void 0 : u.jsOCHelper);
  }
  if (Y.isAndroid(window))
    return V("isAndroid"), (e == null ? void 0 : e.androidJSBridgeObject) || window.android;
  r || _("[hybrid/bridge] Not found jsbridge object, if you are in dev proxy mode, you can skip throw by set getInstance({ config: { softRegisterBridge: true } })!");
}
function Sr(r) {
  Ue = r;
}
function Jr() {
  return bn(window) || De(window) || hn(window) || Ke(window) || Sn();
}
var On = 60, Or = 1, ge = "*";
function Ir(r) {
  return {
    jsCallId: r,
    returnCode: 0,
    result: "success, this is fake response for no response request"
  };
}
/**
 * @license
 * MIT LICENSE
 * Copyright 2011 Jon Leighton
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
var Z = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function jr(r) {
  for (var e = new Uint8Array(r), t = e.byteLength, i = t % 3, a = t - i, s = "", u, v, p, d, w, y = 0; y < a; y = y + 3)
    w = e[y] << 16 | e[y + 1] << 8 | e[y + 2], u = (w & 16515072) >> 18, v = (w & 258048) >> 12, p = (w & 4032) >> 6, d = w & 63, s += Z[u] + Z[v] + Z[p] + Z[d];
  return i == 1 ? (w = e[a], u = (w & 252) >> 2, v = (w & 3) << 4, s += Z[u] + Z[v] + "==") : i == 2 && (w = e[a] << 8 | e[a + 1], u = (w & 64512) >> 10, v = (w & 1008) >> 4, p = (w & 15) << 2, s += Z[u] + Z[v] + Z[p] + "="), s;
}
function Cr() {
  return "id_" + Date.now() + "_" + Math.random().toString(16).slice(2);
}
function un() {
  return Math.random().toString(16).slice(2);
}
function In(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = r, a, s;
  if (i || (i = {}), e)
    for (a in e)
      (t || !(a in i)) && (s = e[a], i[a] = s && s.constructor === Object ? In(i[a], s, t) : s);
  return i;
}
function Nr(r) {
  try {
    return JSON.parse(r);
  } catch (e) {
    M("safeJsonParse got a invalid json string [".concat(r, "] ").concat(e));
  }
  return {};
}
function cn(r) {
  var e = r.replace(/\./g, "\\.");
  return e = e.replace(/\*/g, ".*"), e = "^" + e + "$", new RegExp(e);
}
function ln(r, e) {
  try {
    var t = new URL(r).hostname;
    return e.some(function(i) {
      return i.test(t);
    });
  } catch (i) {
    console.warn("[@zoom/hybrid-jssdk] isValidOrigin error: encountered an invalid domain URL", i);
  }
  return !1;
}
function Fe() {
}
function fn(r, e) {
  for (var t in r)
    r[t] && (e[t] = r[t]);
}
function dn(r) {
  try {
    for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)
      t[i - 1] = arguments[i];
    return r.apply(void 0, t);
  } catch (a) {
    return console.error("[@zoom/hybrid-jssdk] safeInvoke error", a), console.trace("safeInvoke trace"), null;
  }
}
function kr(r, e) {
  for (var t = r; t !== null; ) {
    var i = Object.getOwnPropertyDescriptor(t, e);
    if (i)
      return i.writable === !0 || i.set !== void 0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
var vn = /* @__PURE__ */ function() {
  function r() {
    Q(this, r), G(this, "handlers", void 0), this.handlers = [];
  }
  return $(r, [{
    key: "use",
    value: function(t) {
      return this.handlers.push(t), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
  }, {
    key: "eject",
    value: function(t) {
      return this.handlers[t] ? (this.handlers[t] = null, !0) : !1;
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
  }, {
    key: "clear",
    value: function() {
      this.handlers && (this.handlers = []);
    }
    /**
     * return {Boolean} `true` if the interceptor fn was empty, `false` otherwise
     */
  }, {
    key: "empty",
    value: function() {
      return this.handlers.filter(function(t) {
        return t;
      }).length === 0;
    }
  }]);
}(), Mr = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, [{
    key: "normalizeResponse",
    value: function(t) {
      var i, a, s, u = (i = t.data) !== null && i !== void 0 ? i : t;
      return u.jsCallId === "" && (u.result = u.result || {}, u.result.notification = u.msg_type), T(T({
        returnCode: u.code
      }, u), {}, {
        result: T(T({}, u.jsCallId !== "" && ((a = u.context) !== null && a !== void 0 && a.page) ? {
          notification: (s = u.context) === null || s === void 0 ? void 0 : s.page
        } : {}), u.jsCallId === "" && u.msg_type ? {
          notification: u.msg_type
        } : {})
      });
    }
  }, {
    key: "matchResponse",
    value: function(t) {
      if ("data" in t && Object.keys(t).length === 1) {
        var i = t.data;
        if ("code" in i && "success" in i)
          return !0;
      }
      return "code" in t && "success" in t;
    }
  }, {
    key: "postProcessAsNotification",
    value: function(t) {
      var i, a, s = (i = t.data) !== null && i !== void 0 ? i : t;
      return s.jsCallId !== "" && ((a = s.context) === null || a === void 0 ? void 0 : a.page);
    }
  }]);
}();
function Tr(r) {
  return JSON.stringify(r, function(e, t) {
    return (t == null ? void 0 : t.constructor) === ImageData ? Br(t) : t;
  });
}
function Br(r) {
  return {
    width: r.width,
    height: r.height,
    bitmap: "data:object/Uint8ClampedArray;base64," + jr(r.data)
  };
}
var We = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, [{
    key: "storeBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function i(a, s) {
        var u, v, p;
        return C().w(function(d) {
          for (; ; ) switch (d.p = d.n) {
            case 0:
              if (d.p = 0, a) {
                d.n = 1;
                break;
              }
              return d.a(2, "");
            case 1:
              return d.n = 2, this.serializeBody(a);
            case 2:
              return u = d.v, v = u, v.protocol = s, d.n = 3, this.callNativeStore(v);
            case 3:
              return d.a(2, d.v);
            case 4:
              return d.p = 4, p = d.v, M("@zoom/hybrid-jssdk hook fetch storeBody error", p), d.a(2, "");
          }
        }, i, this, [[0, 4]]);
      }));
      function t(i, a) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "serializeBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function i(a) {
        var s;
        return C().w(function(u) {
          for (; ; ) switch (u.n) {
            case 0:
              return s = {
                encoding: "text",
                body: ""
              }, u.a(2, new Promise(function(v) {
                if (a instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && a instanceof SharedArrayBuffer)
                  s.encoding = "base64", s.body = Ce.convertArrayBufferToBase64(a);
                else if (ArrayBuffer.isView(a))
                  s.encoding = "base64", s.body = Ce.convertArrayBufferToBase64(a.buffer);
                else if (a instanceof File || a instanceof Blob) {
                  s.encoding = "base64";
                  var p = new FileReader();
                  return p.onload = function(d) {
                    s.body = Cn(d.target.result), v(s);
                  }, p.readAsDataURL(a), !0;
                } else {
                  if (a instanceof FormData)
                    return s.encoding = "formData", Ce.convertFormDataToJson(a, function(d) {
                      s.body = d, v(s);
                    }), !0;
                  s.encoding = "text", s.body = a.toString();
                }
                v(s);
              }));
          }
        }, i);
      }));
      function t(i) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "callNativeStore",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function i(a) {
        return C().w(function(s) {
          for (; ; ) switch (s.n) {
            case 0:
              return s.a(2, new Promise(function(u, v) {
                var p = we.getInstance();
                p.postJsMessage({
                  functionName: "http.storeRequestBody",
                  params: a
                }).then(function(d) {
                  if (d.returnCode === 0)
                    u(d.result.bodyId);
                  else {
                    var w;
                    M("http.storeRequestBody failed.", d), v(new Error("[hybrid] http.storeRequestBody failed with returnCode ".concat(d.returnCode, " ").concat((w = d.errorMsg) !== null && w !== void 0 ? w : "")));
                  }
                }).catch(function(d) {
                  M("[hybrid] http.storeRequestBody error", d), v(d);
                });
              }));
          }
        }, i);
      }));
      function t(i) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }, {
    key: "clearBody",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function i(a) {
        return C().w(function(s) {
          for (; ; ) switch (s.n) {
            case 0:
              if (a) {
                s.n = 1;
                break;
              }
              return s.a(2);
            case 1:
              return s.a(2, new Promise(function(u, v) {
                var p = we.getInstance();
                p.postJsMessage({
                  functionName: "http.clearRequestBody",
                  params: {
                    bodyId: a
                  }
                }).then(function(d) {
                  if (d.returnCode === 0)
                    u();
                  else {
                    var w;
                    M("http.clearRequestBody failed.", d), v(new Error("[hybrid] http.clearRequestBody failed with returnCode ".concat(d.returnCode, " ").concat((w = d.errorMsg) !== null && w !== void 0 ? w : "")));
                  }
                }).catch(function(d) {
                  M("[hybrid] http.clearRequestBody error", d), v(d);
                });
              }));
          }
        }, i);
      }));
      function t(i) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }], [{
    key: "getInstance",
    value: function() {
      return r.instance || (r.instance = new r()), r.instance;
    }
  }]);
}();
G(We, "instance", void 0);
var Ve = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, null, [{
    key: "install",
    value: function() {
      this.originalFetch || (this.originalFetch = window.fetch, window.fetch = /* @__PURE__ */ function() {
        var t = H(/* @__PURE__ */ C().m(function i(a, s) {
          return C().w(function(u) {
            for (; ; ) switch (u.n) {
              case 0:
                return u.n = 1, r.interceptedFetch(a, s);
              case 1:
                return u.a(2, u.v);
            }
          }, i);
        }));
        return function(i, a) {
          return t.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "uninstall",
    value: function() {
      this.originalFetch && (window.fetch = this.originalFetch, this.originalFetch = null);
    }
  }, {
    key: "interceptedFetch",
    value: function() {
      var e = H(/* @__PURE__ */ C().m(function i(a, s) {
        var u, v, p, d, w;
        return C().w(function(y) {
          for (; ; ) switch (y.p = y.n) {
            case 0:
              if (!((s == null ? void 0 : s.body) == null || (s == null ? void 0 : s.body) === "")) {
                y.n = 1;
                break;
              }
              return y.a(2, r.originalFetch.call(window, a, s));
            case 1:
              return u = "", v = We.getInstance(), y.p = 2, y.n = 3, v.storeBody(s.body, jn(a));
            case 3:
              return u = y.v, p = T(T({}, s), {}, {
                headers: T(T({}, s.headers), {}, {
                  "X-ZM-Request-Body-ID": u
                }),
                body: s.body
              }), y.n = 4, r.originalFetch.call(window, a, p);
            case 4:
              return d = y.v, y.n = 5, v.clearBody(u);
            case 5:
              return y.a(2, d);
            case 6:
              return y.p = 6, w = y.v, M("FetchInterceptor error", w), y.n = 7, v.clearBody(u);
            case 7:
              throw w;
            case 8:
              return y.a(2);
          }
        }, i, null, [[2, 6]]);
      }));
      function t(i, a) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }]);
}();
G(Ve, "originalFetch", void 0);
var Ne = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, null, [{
    key: "install",
    value: function() {
      this.originalSend || (this.originalSend = XMLHttpRequest.prototype.send, this.originalOpen = XMLHttpRequest.prototype.open, XMLHttpRequest.prototype.open = function(t, i) {
        this._method = t, this._url = i, r.originalOpen.apply(this, arguments);
      }, XMLHttpRequest.prototype.send = /* @__PURE__ */ function() {
        var t = H(/* @__PURE__ */ C().m(function i(a) {
          var s, u, v, p, d, w;
          return C().w(function(y) {
            for (; ; ) switch (y.p = y.n) {
              case 0:
                if (!(a == null || a === "")) {
                  y.n = 1;
                  break;
                }
                return y.a(2, r.originalSend.call(this));
              case 1:
                return s = this.onload, u = this.onerror, v = We.getInstance(), p = "", y.p = 2, y.n = 3, v.storeBody(a, jn(this._url));
              case 3:
                p = y.v, y.n = 5;
                break;
              case 4:
                throw y.p = 4, w = y.v, (d = this.onerror) === null || d === void 0 || d.call(this, w), w;
              case 5:
                return this.setRequestHeader("X-ZM-Request-Body-ID", p), this.onload = /* @__PURE__ */ function() {
                  var D = H(/* @__PURE__ */ C().m(function k(E) {
                    return C().w(function(K) {
                      for (; ; ) switch (K.n) {
                        case 0:
                          return K.n = 1, v.clearBody(p);
                        case 1:
                          s && s.call(this, E);
                        case 2:
                          return K.a(2);
                      }
                    }, k, this);
                  }));
                  return function(k) {
                    return D.apply(this, arguments);
                  };
                }(), this.onerror = /* @__PURE__ */ function() {
                  var D = H(/* @__PURE__ */ C().m(function k(E) {
                    return C().w(function(K) {
                      for (; ; ) switch (K.n) {
                        case 0:
                          return K.n = 1, v.clearBody(p);
                        case 1:
                          u && u.call(this, E);
                        case 2:
                          return K.a(2);
                      }
                    }, k, this);
                  }));
                  return function(k) {
                    return D.apply(this, arguments);
                  };
                }(), y.a(2, r.originalSend.call(this, a));
            }
          }, i, this, [[2, 4]]);
        }));
        return function(i) {
          return t.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "uninstall",
    value: function() {
      this.originalSend && this.originalOpen && (XMLHttpRequest.prototype.send = this.originalSend, XMLHttpRequest.prototype.open = this.originalOpen, this.originalSend = null, this.originalOpen = null);
    }
  }]);
}();
G(Ne, "originalSend", void 0);
G(Ne, "originalOpen", void 0);
var Ce = /* @__PURE__ */ function() {
  function r() {
    Q(this, r);
  }
  return $(r, null, [{
    key: "convertArrayBufferToBase64",
    value: function(t) {
      for (var i = new Uint8Array(t), a = "", s = i.byteLength, u = 0; u < s; u++)
        a += String.fromCharCode(i[u]);
      return window.btoa(a);
    }
  }, {
    key: "convertFormDataToJson",
    value: function(t, i) {
      var a = [];
      r.traversalEntries(t, function(s, u) {
        a.push(r.convertSingleFormDataRecordToArray(s, u));
      }), Promise.all(a).then(i).catch(function(s) {
        M("[hybrid] convertFormDataToJson error", s);
      });
    }
  }, {
    key: "convertSingleFormDataRecordToArray",
    value: function(t, i) {
      return new Promise(function(a, s) {
        if (i instanceof File || i instanceof Blob) {
          var u = new FileReader();
          u.onload = function(v) {
            var p = Cn(v.target.result), d = i instanceof File, w = d ? i.name : "blob", y = {
              headers: ['Content-Disposition: form-data; name="'.concat(t, '"; filename="').concat(w, '"')],
              body: p,
              encoding: "base64"
            };
            return i.type ? y.headers.push("Content-Type: ".concat(i.type)) : y.headers.push("Content-Type: application/octet-stream"), a(y), null;
          }, u.onerror = function(v) {
            return M("[hybrid] read formData failed", v), s(Error("[hybrid] read formData failed")), null;
          }, u.readAsDataURL(i);
        } else
          a({
            headers: ['Content-Disposition: form-data; name="'.concat(t, '"')],
            body: i,
            encoding: "text"
          });
      });
    }
  }]);
}();
G(Ce, "traversalEntries", function(r, e) {
  var t = pn(r.entries()), i;
  try {
    for (t.s(); !(i = t.n()).done; ) {
      var a = i.value, s = a[0], u = a[1];
      e && e(s, u);
    }
  } catch (v) {
    t.e(v);
  } finally {
    t.f();
  }
});
function jn(r) {
  var e;
  if (r instanceof Request ? e = new URL(r.url) : r instanceof URL ? e = r : e = new URL(r), e.protocol === "http:")
    return "http";
  if (e.protocol === "https:")
    return "https";
  throw new Error("Protocol is neither http nor https");
}
function Cn(r) {
  if (!r)
    return "";
  try {
    var e = "base64,", t = r.indexOf(e);
    return t === -1 ? r : r.substring(t + e.length);
  } catch (i) {
    return M("getBase64FromFileReader error:", i), "";
  }
}
function Er() {
  Ve.install(), Ne.install();
}
function Pr() {
  Ve.uninstall(), Ne.uninstall();
}
function Le(r, e) {
  try {
    if (r === "ZoomBundleVersionNumber" || e === "ZoomBundleVersionNumber")
      return console.warn("[hybrid/jssdk] Skip version check for local development build! 🚀"), 1;
    for (var t = r.split(".").map(Number), i = e.split(".").map(Number), a = Math.max(t.length, i.length), s = 0; s < a; s++) {
      var u = t[s] || 0, v = i[s] || 0;
      if (u > v) return 1;
      if (u < v) return -1;
    }
    return 0;
  } catch (p) {
    return console.error("[@zoom/hybrid-jssdk] compareVersions error:", p, "version1", r, "version2", e), -1;
  }
}
function Rr() {
  try {
    var r, e;
    if ((r = window.unifyConfig) !== null && r !== void 0 && r.systemParam)
      return window.unifyConfig.systemParam.clientVersion;
    if (typeof ((e = window.android_config) === null || e === void 0 ? void 0 : e.getSystemParam) == "function")
      return JSON.parse(window.android_config.getSystemParam()).clientVersion;
  } catch (t) {
    console.error("[@zoom/hybrid-jssdk] getClientVersion error:", t, "window.unifyConfig", window.unifyConfig, "window.android_config", window.android_config);
  }
}
var gn = !1;
function we() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = Fr(r), t = sn(e.config.softRegisterBridge, e.platform, e.config.legacyPlatformDetection);
  if (!t && e.config.strictMode)
    throw new Error("[@zoom/hybrid-jssdk] Not found jsbridge object. ".concat(de, " build at ").concat(je));
  V("getCurrentJSBridgeObject", t), Sr(e.config.legacyPlatformDetection);
  var i = {}, a = {}, s = {}, u = {}, v = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), w, y, D = [], k = [], E = {}, K = {
    info: Fe,
    warn: Fe,
    error: Fe
  }, he = e.debug, ke = he.enable, oe = he.output, O = T({}, ke && oe ? oe : K), I = e.config.unifySDKMode ? "unifySdk" : "zoomSdk", x = !window[I], A = x ? "master_".concat(un()) : "sub_".concat(un()), j = [], B = Rr(), U = {
    request: new vn(),
    response: new vn()
  }, ae = [];
  e.config.disabledAdapters.includes("AdvancedDiagnosticsAdapter") || (O.info("%c advancedDiagnosticsAdapter enabled!", "color: green; font-weight: bold"), ae.push(new Mr())), Bn();
  function X(n) {
    z(ge, n);
  }
  function z(n, o) {
    var c = Array.isArray(n) ? n : [n];
    c.forEach(function(l) {
      var f = u[l];
      f ? f.push(o) : u[l] = [o];
    });
  }
  function ne(n) {
    P(ge, n);
  }
  function P(n, o) {
    var c = Array.isArray(n) ? n : [n];
    c.forEach(function(l) {
      if (o) {
        var f = u[l];
        if (f) {
          var g = f.indexOf(o);
          g !== -1 && (f.splice(g, 1), u[l] = f);
        }
      } else
        u[l] = [];
    });
  }
  function N(n) {
    var o, c, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      isIOSSupport: !0,
      isAndroidSupport: !0,
      isMacSupport: !0,
      isWindowsSupport: !0,
      isLinuxSupport: !0
    }, f = n.jsCallId, g = n.functionName, S = g === void 0 ? "" : g, h = n.params, m = h === void 0 ? {} : h, b = n.timeout, F = b === void 0 ? e == null || (o = e.config) === null || o === void 0 ? void 0 : o.messageTimeout : b, q = n.raceMode, ue = q === void 0 ? !1 : q, te = n.needResponse, Oe = te === void 0 ? !0 : te, Ie = n.overwriteResponse, Pe = Ie === void 0 ? !1 : Ie, ie = n.moduleName, ce = ie === void 0 ? "" : ie, le = n.noDelete, or = le === void 0 ? !1 : le, fe = {
      functionName: S,
      params: m,
      timeout: F,
      raceMode: ue,
      needResponse: Oe,
      overwriteResponse: Pe,
      moduleName: ce,
      noDelete: or,
      jsCallId: f,
      rejectOnErrorResponse: (c = n.rejectOnErrorResponse) !== null && c !== void 0 ? c : e.config.checkReturnCode
    };
    !S && n.apiName && (fe.apiName = n.apiName, fe.data = n.data);
    var L = kn(fe);
    return L = JSON.parse(JSON.stringify(T(T({}, L), l))), L = W(L), new Promise(function(en, nn) {
      fe.needResponse ? Mn(L, en, nn) : (O.warn("%c The native client request(".concat(L.functionName || L.apiName, "__").concat(L.jsCallId, ") with needResponse:false."), "color: warn;", fe), en(Ir(L.jsCallId)));
      var rn = window.top !== window;
      if (O.info("".concat(rn ? "Iframe" : "", " request %c").concat(L.functionName || L.apiName, "__").concat(L.jsCallId), "color:#909399; font-weight: bold", L), rn)
        if (e.config.iframeSupport)
          window.top.postMessage({
            identityKey: e.config.iframeMessageIdentityKey,
            fromIframeURL: window.location.href,
            request: T({}, L)
          }, "*");
        else
          return nn(new Error("JSBridge does not support calls within iframes. If iframe support is needed, please set the iframeSupport parameter."));
      else {
        var Re;
        (Re = window[I]) === null || Re === void 0 || Re.postMessage(L);
      }
    });
  }
  function W(n) {
    if (U.request.empty())
      return n;
    for (var o = n.functionName, c = n.apiName, l = n.jsCallId, f = n.params, g = n.data, S = U.request.handlers.filter(function(b) {
      return b;
    }), h = 0; h < S.length; h++)
      if (S[h]) {
        var m = S[h]({
          functionName: o,
          apiName: c,
          params: f,
          data: g,
          jsCallId: l
        });
        f = m == null ? void 0 : m.params, g = m == null ? void 0 : m.data, n.params && !f && O.warn("%cThe request interceptor returned empty parameters!!!", "color: brown; font-weight: bold", "interceptor return", m), n.data && !g && O.warn("%cThe request interceptor returned empty data!!!", "color: brown; font-weight: bold", "interceptor return", m);
      }
    return n.params && (n.params = f), n.data && (n.data = g), T({}, n);
  }
  function R(n) {
    if (U.response.empty())
      return n;
    for (var o = n, c = U.response.handlers.filter(function(f) {
      return f;
    }), l = 0; l < c.length; l++)
      c[l] && (o = c[l](o), o || O.warn("%cThe response interceptor should not return an empty response!!!", "color: brown; font-weight: bold", "interceptor response", o));
    return o;
  }
  function se(n) {
    if (n)
      clearTimeout(s[n]), delete s[n], O.info("Remove ".concat(n, " API timer successfully."));
    else {
      for (var o in s)
        clearTimeout(s[o]);
      s = {};
    }
  }
  function re() {
    var n, o;
    i = {}, a = {}, p.clear(), v.clear(), d.clear(), (n = w) === null || n === void 0 || (o = n.destroy) === null || o === void 0 || o.call(n);
  }
  function Nn() {
    u = {};
  }
  function be(n) {
    try {
      if (t || (t = sn(e.config.softRegisterBridge, e.platform, e.config.legacyPlatformDetection)), t) {
        var o = n.iframeWindow;
        n.iframeWindow = null;
        var c = e.config.messageFormat === "string" ? Tr(n) : n;
        if (o && e.config.iframeSupport && (E[n.jsCallId] = o), n.raceMode) {
          var l = Ye(n);
          v.has(l) ? v.get(l).push(n.jsCallId) : (p.set(n.jsCallId, l), v.set(l, [n.jsCallId]), t.postMessage(c));
        } else
          t.postMessage(c);
      } else
        O.warn(`%cFailed to post a message. The JS bridge object was not found.
!`, "color: brown; font-weight: bold");
    } catch (f) {
      M("Failed to post a message.", f);
    }
  }
  function kn(n) {
    var o, c, l, f;
    if (!n.functionName && !n.apiName) {
      var g = "[@zoom/hybrid-jssdk] Invalid message format: Both functionName and apiName cannot be empty.";
      throw M(g, n), new Error(g);
    }
    if (n.functionName && n.apiName && _("[@zoom/hybrid-jssdk] Invalid message format: Both functionName and apiName cannot exist simultaneously.", n), n.timeout !== void 0 && n.timeout < 0) {
      var S = "[@zoom/hybrid-jssdk] Invalid message format: Timeout value cannot be negative. Using the default timeout ".concat(e.config.messageTimeout, " instead.");
      _(S, n), n.timeout = e.config.messageTimeout;
    }
    return T(T({
      iframeWindow: null
    }, n), {}, {
      sdkName: I,
      timeout: (o = (c = n.timeout) !== null && c !== void 0 ? c : e == null || (l = e.config) === null || l === void 0 ? void 0 : l.messageTimeout) !== null && o !== void 0 ? o : On,
      jsCallId: (f = n.jsCallId) !== null && f !== void 0 ? f : Cr()
    });
  }
  function Mn(n, o, c) {
    var l, f = Date.now();
    if (n.timeout && !n.noDelete) {
      var g = Ye(n);
      l = setTimeout(function() {
        var S = "The native client did not respond to the API call (".concat(n.functionName || n.apiName, "__").concat(n.jsCallId, "). timeout is ").concat(n.timeout, " seconds");
        qn(n), window.top && window.top !== window && window.top.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          fromIframeURL: window.location.href,
          purpose: "cleanTimeoutJsCall",
          raceId: g,
          timeoutJsCallId: n.jsCallId
        }, "*"), M(S, n), xn({
          reject: c,
          errorMessage: S,
          jsCallId: n.jsCallId
        });
      }, n.timeout * 1e3), s[n.jsCallId] = l;
    }
    d.set(n.jsCallId, c), Tn(n, l, function(S) {
      var h = e.config.longRequestSeconds, m = typeof S == "string" ? JSON.parse(S) : S;
      m = JSON.parse(JSON.stringify(m));
      var b = m;
      m.data && !m.jsCallId && (b = m.data), b = R(b), b || c("[hybrid/bridge] callResponseInterceptor return a empty response, please check your response");
      var F = b, q = F.returnCode, ue = F.errorCode;
      if (n.rejectOnErrorResponse && (ue || q)) {
        var te, Oe = b, Ie = Oe.errorCode, Pe = Oe.errorMessage;
        O.error("hybrid reject for error response", b), c(new zr(Pe || "hybrid reject for error response ".concat((te = n.functionName) !== null && te !== void 0 ? te : n.apiName), Ie || q, n.jsCallId, b));
      } else
        o(b);
      if (Se(n.jsCallId), l && clearTimeout(l), delete s[n.jsCallId], e.debug.enable) {
        var ie = Date.now(), ce = parseFloat((ie - f).toFixed(2)), le = window.top !== window ? "iframe received " : "";
        h && ce >= h * 1e3 ? O.warn("%c ".concat(ce, "ms ").concat(le, " Slow API response ").concat(n.functionName || n.apiName, "__").concat(n.jsCallId, " requestTime: ").concat(ve(new Date(f)), " responseTime: ").concat(ve(new Date(ie))), "font-weight: bold", m) : O.info("".concat(ce, "ms ").concat(le, " response %c").concat(n.functionName || n.apiName, "__").concat(n.jsCallId, "%c requestTime: ").concat(ve(new Date(f)), " responseTime: ").concat(ve(new Date(ie))), "color:#".concat(q === 0 ? "67C23A" : "F56C6C", ";font-weight: bold"), "", m);
      }
    });
  }
  function Tn(n, o, c) {
    if (i[n.jsCallId] = c, n.overwriteResponse) {
      var l = n.functionName || n.apiName;
      if (a[l]) {
        var f = a[l];
        O.info("remove call id: ", f.callID), clearTimeout(f.timerHandler), Se(f.callID), n.overwriteResponse && Xn(n);
      }
      a[l] = {
        callID: n.jsCallId,
        timerHandler: o
      };
    }
  }
  function Bn() {
    try {
      if (window[I] && !e.config.sharedBridge && !gn) {
        var n;
        if (!e.config.softRegisterBridge) {
          var o = "[@zoom/hybrid-jssdk] Failed to register the SDK object for ".concat(I, " because it already exists.");
          throw M(o, window.top !== window), new Error(o);
        }
        if (((n = window[I]) === null || n === void 0 ? void 0 : n.constructor) !== Object) {
          var c = "[@zoom/hybrid-jssdk] Failed to inject window.".concat(I, ". The window.").concat(I, " object should be a plain object.");
          throw M(c, window[I]), new Error(c);
        }
      }
      e.config.iframeSupport && (window.top === window ? w = Fn() : w = Ln());
      var l = {
        native2js: ee,
        postJSMessage: N,
        postJsMessage: N,
        postMessage: be,
        registerSubInstance: Be,
        unregisterSubInstance: Ee,
        isInstanceRegistered: Te,
        buildInfo: {
          buildTime: je,
          version: de
        }
      };
      if (x) {
        var f;
        O.info("%c start register master ".concat(I, "..."), "font-weight: bold", {
          sdkObject: window[I],
          sdkName: I,
          bridgeOptions: e
        }), e.config.softRegisterBridge || gn ? (window[I] || (window[I] = {
          native2js: ee,
          registerSubInstance: Be,
          unregisterSubInstance: Ee,
          isInstanceRegistered: Te,
          postJSMessage: N,
          postJsMessage: N,
          postMessage: be,
          buildInfo: {
            buildTime: je,
            version: de
          }
        }), fn(window[I], l), e.config.unifySDKMode ? e.config.isInterceptZoomSdkNative2js && Ge() : (window.unifySdk = {
          native2js: ee,
          registerSubInstance: Be,
          unregisterSubInstance: Ee,
          isInstanceRegistered: Te,
          postJSMessage: N,
          postJsMessage: N,
          postMessage: be,
          buildInfo: {
            buildTime: je,
            version: de
          }
        }, fn(window.unifySdk, l))) : (Object.defineProperty(window, I, {
          value: l,
          writable: !1,
          enumerable: !1
        }), e.config.unifySDKMode ? e.config.isInterceptZoomSdkNative2js && Ge() : Object.defineProperty(window, "unifySdk", {
          value: l,
          writable: !1,
          enumerable: !1
        })), Y.isWebView2(window) && typeof ((f = window.chrome) === null || f === void 0 || (f = f.webview) === null || f === void 0 ? void 0 : f.addEventListener) == "function" && (y && window.chrome.webview.removeEventListener("message", y), window.chrome.webview.addEventListener("message", y = function(h) {
          h instanceof Event && h.data ? l.native2js(JSON.parse(JSON.stringify(h.data))) : l.native2js(h);
        })), O.info("%c register master ".concat(I, " successfully!"), "color: green; font-weight: bold", {
          sdkObject: window[I],
          unifySdkObject: window.unifySdk,
          sdkName: I,
          bridgeOptions: e
        }), Pn();
      } else {
        var g;
        O.info("%c start register sub ".concat(I, " (").concat(A, ")..."), "font-weight: bold", {
          sdkObject: window[I],
          sdkName: I,
          bridgeOptions: e
        }), (g = window[I]) === null || g === void 0 || g.registerSubInstance({
          instanceId: A,
          onNativeResponse: ee,
          isJsCallIdFromThisInstance: _n,
          isThisInstanceRegisteredNotification: An
        });
      }
    } catch (S) {
      O.error("%c register ".concat(I, " failed!"), "color: red; font-weight: bold", {
        error: S,
        sdkObject: window[I],
        sdkName: I,
        bridgeOptions: e
      });
    }
  }
  function Ge() {
    if (window.zoomSdk)
      if (kr(window.zoomSdk, "native2js")) {
        var n = window.zoomSdk.native2js.bind(window.zoomSdk);
        window.zoomSdk.native2js = function(o) {
          var c = JSON.stringify(o);
          dn(n, JSON.parse(c)), dn(window.unifySdk.native2js, JSON.parse(c));
        }, O.info("%c intercepted zoomSdk.native2js successfully!", "color: green; font-weight: bold");
      } else
        O.warn("failed to intercept zoomSdk.native2js, window.zoomSdk.native2js is not writable.", window.zoomSdk);
    else
      O.warn("config isInterceptZoomSdkNative2js: true, but not found window.zoomSdk.native2js, zoomSdk is ", window.zoomSdk);
  }
  function ee(n) {
    return Me.apply(this, arguments);
  }
  function Me() {
    return Me = H(/* @__PURE__ */ C().m(function n(o) {
      var c, l, f, g, S, h, m;
      return C().w(function(b) {
        for (; ; ) switch (b.p = b.n) {
          case 0:
            c = [].concat(pr(D.map(function(F) {
              return F.handler;
            })), [Hn]), l = o, f = pn(c), b.p = 1, f.s();
          case 2:
            if ((g = f.n()).done) {
              b.n = 7;
              break;
            }
            if (S = g.value, l === void 0) {
              b.n = 6;
              break;
            }
            return b.p = 3, b.n = 4, S(l);
          case 4:
            l = b.v, b.n = 6;
            break;
          case 5:
            b.p = 5, h = b.v, console.error("Error in handler:", h);
          case 6:
            b.n = 2;
            break;
          case 7:
            b.n = 9;
            break;
          case 8:
            b.p = 8, m = b.v, f.e(m);
          case 9:
            return b.p = 9, f.f(), b.f(9);
          case 10:
            return b.a(2);
        }
      }, n, null, [[3, 5], [1, 8, 9, 10]]);
    })), Me.apply(this, arguments);
  }
  function En(n) {
    var o = n.handler, c = n.priority, l = c === void 0 ? 0 : c, f = D.findIndex(function(g) {
      return g.priority < l;
    });
    f === -1 ? D.push({
      handler: o,
      priority: l
    }) : D.splice(f, 0, {
      handler: o,
      priority: l
    });
  }
  function Pn() {
    N({
      functionName: "webview.ready",
      params: {},
      needResponse: !1
    }), !e.config.allowPendingNotification && window.__unfiySdk_pending_notification && _("[hybrid/bridge] not allow to check pending message, but __unfiySdk_pending_ has message in it."), e.config.isHookRequestBody && (window.zapp_local_load === "yes" ? xe() : _("Skip registerRequestBodyHook, window.zapp_local_load is undefined!"));
  }
  function Rn() {
    if (e.config.allowPendingNotification) {
      var n;
      (n = window.__unfiySdk_pending_notification) === null || n === void 0 || n.forEach(/* @__PURE__ */ function() {
        var o = H(/* @__PURE__ */ C().m(function c(l) {
          var f;
          return C().w(function(g) {
            for (; ; ) switch (g.p = g.n) {
              case 0:
                return g.p = 0, g.n = 1, ee(l);
              case 1:
                g.n = 3;
                break;
              case 2:
                g.p = 2, f = g.v, _("[hybrid/bridge] handle __unfiySdk_pending_notification error", f, l);
              case 3:
                return g.a(2);
            }
          }, c, null, [[0, 2]]);
        }));
        return function(c) {
          return o.apply(this, arguments);
        };
      }()), delete window.__unfiySdk_pending_notification;
    } else
      _("[hybrid/bridge] skip checkPendingNotification, due to allowPendingNotification was false");
  }
  function Fn() {
    e.config.iframeAllowedOrigin.length || _("[hybrid] iframeSupport was true, but iframeAllowedOrigin is empty, please add origin in bridge config.");
    var n = e.config.iframeAllowedOrigin.map(cn), o = function(l) {
      var f = l.data, g = l.origin, S = ln(l.origin, n), h = e.config.iframeAllowNullOrigin && l.origin === "null";
      if ((S || h) && (f == null ? void 0 : f.identityKey) === e.config.iframeMessageIdentityKey) {
        var m = f.request, b = f.purpose, F = f.timeoutJsCallId, q = f.raceId;
        if (b === "registerIframe")
          er(l.source);
        else if (b === "unregisterIframe")
          nr(l.source);
        else if (b === "cleanTimeoutJsCall" && F)
          Jn({
            jsCallId: F,
            raceId: q
          });
        else {
          var ue = e.config.iframeOriginalValidator || function() {
            return !0;
          };
          ue(l) ? (m.needResponse && (m.iframeWindow = l.source), be(m)) : O.warn("[hybrid] Received a message rejected by custom iframeOriginalValidator!", l);
        }
      } else (f == null ? void 0 : f.identityKey) === e.config.iframeMessageIdentityKey && O.warn("[hybrid] Received a invalid message or message sent from invalid origin ".concat(g), l);
    };
    return window.removeEventListener("message", o), window.addEventListener("message", o), {
      destroy: function() {
        window.removeEventListener("message", o), w = null;
      }
    };
  }
  function Ln() {
    if (!e.config.iframeAllowedOrigin.length)
      throw new Error("[@zoom/hybrid-jssdk] iframeSupport was true, but iframeAllowedOrigin is empty. Please add an origin to the bridge config’s iframeAllowedOrigin field, or disable iframe support.");
    var n = e.config.iframeAllowedOrigin.map(cn), o = /* @__PURE__ */ function() {
      var c = H(/* @__PURE__ */ C().m(function l(f) {
        var g, S, h, m, b;
        return C().w(function(F) {
          for (; ; ) switch (F.n) {
            case 0:
              if (g = f.data, S = f.origin, h = ln(f.origin, n), m = e.config.iframeAllowNullOrigin && f.origin === "null", !((h || m) && (g == null ? void 0 : g.identityKey) === e.config.iframeMessageIdentityKey)) {
                F.n = 2;
                break;
              }
              return b = g.response, F.n = 1, ee(b);
            case 1:
              F.n = 3;
              break;
            case 2:
              (g == null ? void 0 : g.identityKey) === e.config.iframeMessageIdentityKey && O.warn("[hybrid] got a message from invalid origin ".concat(S), f);
            case 3:
              return F.a(2);
          }
        }, l);
      }));
      return function(f) {
        return c.apply(this, arguments);
      };
    }();
    return window.removeEventListener("message", o), window.addEventListener("message", o), window.top.postMessage({
      identityKey: e.config.iframeMessageIdentityKey,
      fromIframeURL: window.location.href,
      purpose: "registerIframe"
    }, "*"), {
      destroy: function() {
        window.removeEventListener("message", o), window.top.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          fromIframeURL: window.location.href,
          purpose: "unregisterIframe"
        }, "*"), w = null;
      }
    };
  }
  function Te(n) {
    if (!x) {
      var o = "[@zoom/hybrid-jssdk] can't call isInstanceRegistered on sub, current instanceId ".concat(n);
      throw M(o), new Error(o);
    }
    return j.some(function(c) {
      return c.instanceId === n;
    });
  }
  function Be(n) {
    var o;
    if (!x) {
      var c = "[@zoom/hybrid-jssdk] can’t registerSubInstance on sub, current instanceId ".concat(A);
      throw M(c), new Error(c);
    }
    (o = window[I]) !== null && o !== void 0 && o.isInstanceRegistered(n.instanceId) ? _("[Bridge::registerSubInstance] instance ".concat(n.instanceId, " already registered!")) : (j.push(n), V("%c register sub ".concat(I, " ").concat(n.instanceId, " successfully!"), "color: green; font-weight: bold", j));
  }
  function Ee(n) {
    var o;
    if (!x) {
      var c = "[@zoom/hybrid-jssdk] can’t unregisterSubInstance on sub. instanceId: ".concat(n);
      throw M(c), new Error(c);
    }
    if ((o = window[I]) !== null && o !== void 0 && o.isInstanceRegistered(n)) {
      var l = j.findIndex(function(f) {
        return f.instanceId === n;
      });
      j.splice(l, 1), V("%c unregister sub ".concat(I, " ").concat(n, " successfully!"), "font-weight: bold", j);
    } else
      _("[Bridge::unregisterSubInstance] instance ".concat(n, " not registered!"));
  }
  function _n(n) {
    return !!i[n];
  }
  function An(n) {
    return !!u[n] || !!u[ge];
  }
  function zn() {
    var n;
    (n = window[I]) === null || n === void 0 || n.unregisterSubInstance(A);
  }
  function Ze() {
    k = k.filter(function(n) {
      return !n.closed;
    }), Object.keys(E).forEach(function(n) {
      var o = E[n];
      o.closed && delete E[n];
    });
  }
  function Jn(n) {
    if (window.top === window) {
      var o = n.jsCallId, c = n.raceId;
      E[o] && o && delete E[o], c && v.has(c) && (v.delete(c), p.delete(o)), Ze();
    }
  }
  function Hn(n) {
    if (Ze(), !n || Ae(n) !== "object") {
      O.warn("Native client send a invalid response to jsbridge, ignore it!", n);
      return;
    }
    var o = ae.find(function(S) {
      return S.matchResponse(n);
    }), c = o ? o.normalizeResponse(n) : Dn(n);
    if (c) {
      var l = c.jsCallId;
      if (l) {
        if (i[l]) {
          var f, g;
          (f = (g = i)[l]) === null || f === void 0 || f.call(g, c);
        } else E[l] ? (Yn(E[l], n), delete E[l]) : Qn(l, n);
        $n(l, n);
      } else
        Xe(c), Qe(c), $e(c);
      o != null && o.postProcessAsNotification(n) && (Xe(c), Qe(c), $e(c));
    }
  }
  function Xe(n) {
    var o, c = n == null || (o = n.result) === null || o === void 0 ? void 0 : o.notification, l = n.type === "event" && !!n.name;
    if (l && !c && (c = n.name, n.result.notification = n.name), c) {
      O.info("%c".concat(l ? "Event" : "", " ").concat(c), "color: #0f00f0;font-weight:bold", n);
      var f = u[c], g = u[ge];
      f != null && f.length ? qe(f, n) : g != null && g.length || j.filter(function(S) {
        return S.isThisInstanceRegisteredNotification(c);
      }).length === 0 && O.info("%cReceived an unregistered notification: ".concat(c, ". Ignoring it."), "color:#909399;", n), g && qe(g, n);
    } else
      O.warn(`Failed to handle notification. The 'notification' field is missing in the response.
`, n);
  }
  function qe(n, o) {
    n.slice().forEach(function(c) {
      try {
        c(o);
      } catch (l) {
        M("invoke handler error", {
          e: l,
          handler: c,
          message: o
        });
      }
    });
  }
  function Dn(n) {
    if (Gn(n))
      return Vn(n);
    var o = n;
    if ("jsCallId" in o)
      return o;
    if (Kn(o)) {
      var c = Un(o);
      if (c.type === _r) {
        var l, f;
        return T({
          jsCallId: (l = c.data.jsCallId) !== null && l !== void 0 ? l : "",
          returnCode: +((f = c.data.errorCode) !== null && f !== void 0 ? f : 0)
        }, c.data);
      } else if (c.type === Ar) {
        var g, S, h = c.data || {};
        return typeof h.eventData == "string" && (h.eventData = Nr(h.eventData)), {
          jsCallId: "",
          returnCode: +((g = h.errorCode || ((S = h.eventData) === null || S === void 0 ? void 0 : S.returnCode)) !== null && g !== void 0 ? g : 0),
          result: T({
            notification: h.eventName || c.name
          }, h)
        };
      } else
        O.warn("Received an invalid appBridge response data structure, discarding it.", o);
    } else {
      if ("data" in o)
        return o.data;
      if (!o.jsCallId && "returnCode" in o && "result" in o && !("notification" in o))
        return o;
      var m = Wn(o);
      if (m)
        return m;
      O.warn("[hybrid] Received an invalid response data structure, discarding it.", o);
    }
  }
  function Kn(n) {
    if ("data" in n && "type" in n && (n.type === "event" && "name" in n || n.type === "apiResponse" && !("name" in n)))
      return !0;
    if ("data" in n && "data" in n.data && !("type" in n)) {
      var o = n.data;
      if (o.type === "event" && "name" in o || o.type === "apiResponse" && !("name" in o))
        return !0;
    }
    return !1;
  }
  function Un(n) {
    if ("data" in n && "data" in n.data && !("type" in n))
      return n.data;
    if ("data" in n && "type" in n)
      return n;
  }
  function Wn(n) {
    return n.notification === "UnifyNotif_OnNetworkStateChanged" ? {
      jsCallId: "",
      returnCode: 0,
      result: T({}, n)
    } : !1;
  }
  function Vn(n) {
    if (n.version === "v1.0") {
      if (n.type === "unifyNotification")
        return {
          jsCallId: "",
          returnCode: n.returnCode,
          errorMsg: n.errorMsg,
          result: {
            data: T({}, n.data),
            notification: n.notification
          }
        };
      if (n.type === "unifyResponse")
        return {
          jsCallId: n.jsCallId,
          returnCode: n.returnCode,
          errorMsg: n.errorMsg,
          result: T({}, n.data)
        };
    }
    throw new Error("[@zoom/hybrid-jssdk] new response message version is not supported. version: ".concat(n.version));
  }
  function Gn(n) {
    return "type" in n && "version" in n ? n.type === "unifyNotification" || n.type === "unifyResponse" : !1;
  }
  function Se(n) {
    delete i[n];
  }
  function Zn(n) {
    return i[n];
  }
  function Xn(n) {
    var o = n.functionName || n.apiName;
    a[o] && delete a[o];
  }
  function qn(n) {
    try {
      e.config.onMessageTimeout && e.config.onMessageTimeout(n);
    } catch (o) {
      M("invoke message timeout callback error", o);
    }
  }
  function Ye(n) {
    var o, c, l;
    return "F:".concat((o = n.functionName) !== null && o !== void 0 ? o : n.apiName, "_P:").concat(JSON.stringify((c = n.params) !== null && c !== void 0 ? c : {}), "_D:").concat(JSON.stringify((l = n.data) !== null && l !== void 0 ? l : {}));
  }
  function Yn(n, o) {
    if (e.config.iframeSupport)
      try {
        O.info("%c forward response message to iframe!", "font-weight: bold", o), n.closed || n.postMessage({
          identityKey: e.config.iframeMessageIdentityKey,
          response: o
        }, "*");
      } catch (c) {
        M("[hybrid] forward response message to iframe error", c);
      }
  }
  function Qe(n) {
    e.config.iframeSupport && k.length && (O.info("%c forward notification to iframe!", "font-weight: bold", n), k.filter(function(o) {
      return !o.closed;
    }).forEach(function(o) {
      o.postMessage({
        identityKey: e.config.iframeMessageIdentityKey,
        response: n
      }, "*");
    }));
  }
  function Qn(n, o) {
    j.length && j.filter(function(c) {
      return c.isJsCallIdFromThisInstance(n);
    }).map(function(c) {
      c.onNativeResponse(o);
    });
  }
  function $e(n) {
    j.length && j.map(function(o) {
      o.onNativeResponse(n);
    });
  }
  function $n(n, o) {
    var c = p.get(n);
    if (c) {
      var l;
      (l = v.get(c)) === null || l === void 0 || l.forEach(/* @__PURE__ */ function() {
        var f = H(/* @__PURE__ */ C().m(function g(S) {
          var h;
          return C().w(function(m) {
            for (; ; ) switch (m.n) {
              case 0:
                if (S === n) {
                  m.n = 1;
                  break;
                }
                return h = JSON.parse(JSON.stringify(o)), h.jsCallId = S, m.n = 1, ee(h);
              case 1:
                return m.a(2);
            }
          }, g);
        }));
        return function(g) {
          return f.apply(this, arguments);
        };
      }()), p.delete(n), v.delete(c);
    }
  }
  function xn(n) {
    var o = n.reject, c = n.errorMessage, l = n.jsCallId, f = p.get(l), g = new Error(c);
    if (f) {
      var S = v.get(f) || [];
      S.forEach(function(h) {
        var m;
        delete s[h], Se(h), (m = d.get(h)) === null || m === void 0 || m(g), d.delete(h);
      }), p.delete(l), v.delete(f), d.delete(l);
    } else
      delete s[l], d.delete(l), Se(l), o(g);
  }
  function er(n) {
    k.includes(n) || k.push(n);
  }
  function nr(n) {
    var o = k.indexOf(n);
    o > -1 && k.splice(o, 1);
  }
  function xe() {
    Y.isMacOSWebkit(window) && Le(B, "6.3.0") >= 0 || Y.isIOS(window) && Le(B, "6.6.0") >= 0 ? (Er(), V("%c hooked fetch/XMLHTTPRequest successfully!", "color: green; font-weight: bold")) : _("Skip registerRequestBodyHook, the iOS client version must be 6.6.0 or higher/ The Mac Zoom Client version must be 6.3.0 or higher. current client version(".concat(B, ")!"));
  }
  function rr() {
    Y.isMacOS(window) && Le(B, "6.3.0") >= 0 ? (Pr(), V("%c remove fetch/XMLHTTPRequest Hook successfully!", "color: brown; font-weight: bold")) : _("Skip unregisterRequestBodyHook, the iOS client version must be 6.6.0 or higher/ The Mac Zoom Client version must be 6.3.0 or higher. current client version(".concat(B, ")!"));
  }
  function tr() {
    return JSON.parse(JSON.stringify(e));
  }
  function ir() {
    return O;
  }
  return {
    config: me,
    getInstance: me,
    addNativeResponseHandler: En,
    registerNotificationHandler: X,
    checkPendingNotification: Rn,
    registerSpecificNotificationHandler: z,
    unregisterNotificationHandler: ne,
    unregisterSpecificNotificationHandler: P,
    unregisterInstance: zn,
    postJsMessage: N,
    postJSMessage: N,
    clearTimeHandler: se,
    clearAPICallback: re,
    clearNotificationHandler: Nn,
    registerRequestBodyHook: xe,
    unregisterRequestBodyHook: rr,
    getNativeApiCallback: Zn,
    interceptors: U,
    getBridgeOptions: tr,
    getLogger: ir
  };
}
function Fr() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return In({
    config: {
      messageTimeout: On,
      longRequestSeconds: Or,
      wildCardNotificationType: ge,
      softRegisterBridge: !1,
      unifySDKMode: !1,
      messageFormat: "string",
      iframeSupport: !1,
      iframeAllowNullOrigin: !1,
      iframeAllowedOrigin: ["*"],
      iframeMessageIdentityKey: "ZM_UNIFY_HYBRID_MSG",
      sharedBridge: !0,
      allowPendingNotification: !0,
      disabledAdapters: [],
      isHookRequestBody: !1,
      iframeOriginalValidator: null,
      serviceHubSkipAddEventListener: !1,
      isInterceptZoomSdkNative2js: !1,
      checkReturnCode: !1,
      legacyPlatformDetection: !1,
      strictMode: !1
    },
    debug: {
      enable: !0,
      output: {
        info: V,
        warn: _,
        error: M
      }
    }
  }, r);
}
function Lr() {
  var r;
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return r ? (e && JSON.stringify(e) !== "{}" && _("Hybrid/bridge is already configured. The current options in getInstance will be ignored. You can call hybrid.config first to bypass this warning.", e), r) : r = we(e);
  };
}
var me = Lr();
we.getInstance = me;
we.config = me;
var Hr = me, _r = "apiResponse", Ar = "event", zr = /* @__PURE__ */ function(r) {
  function e(t, i, a, s) {
    var u;
    return Q(this, e), u = ur(this, e, [t]), G(u, "code", void 0), G(u, "requestId", void 0), G(u, "response", void 0), u.code = i, u.requestId = a, u.response = s, Object.setPrototypeOf(u, e.prototype), u;
  }
  return lr(e, r), $(e);
}(/* @__PURE__ */ ze(Error));
export {
  we as Bridge,
  zr as ZoomApiResponseError,
  Le as compareVersions,
  Hr as config,
  Cr as getJsCallId,
  Jr as isInWebview,
  Y as platformBridgeChecker
};
//# sourceMappingURL=hybrid-jsbridge.es.js.map
